import { useState, useCallback } from "react";

/**
 * Hook for managing scanner controls state
 * (Database, Table, Region selection and their loading states)
 */
export const useScannerState = () => {
  const [databases, setDatabases] = useState([]);
  const [tables, setTables] = useState([]);
  const [regions, setRegions] = useState([]);
  const [regionDisplayMap, setRegionDisplayMap] = useState({});
  const [regionsData, setRegionsData] = useState([]);
  
  const [selectedDatabase, setSelectedDatabase] = useState("");
  const [selectedTables, setSelectedTables] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState("");
  
  const [showDatabaseDropdown, setShowDatabaseDropdown] = useState(false);
  const [showTableDropdown, setShowTableDropdown] = useState(false);
  const [showRegionDropdown, setShowRegionDropdown] = useState(false);
  
  const [loadingDatabases, setLoadingDatabases] = useState(false);
  const [loadingTables, setLoadingTables] = useState(false);
  const [loadingRegions, setLoadingRegions] = useState(false);
  
  const [dataSourceId, setDataSourceId] = useState(null);

  const resetSelections = useCallback(() => {
    setSelectedDatabase("");
    setSelectedRegion("");
    setDatabases([]);
    setTables([]);
    setDataSourceId(null);
  }, []);

  return {
    // Databases
    databases,
    setDatabases,
    selectedDatabase,
    setSelectedDatabase,
    loadingDatabases,
    setLoadingDatabases,
    showDatabaseDropdown,
    setShowDatabaseDropdown,
    
    // Tables
    tables,
    setTables,
    selectedTables,
    setSelectedTables,
    loadingTables,
    setLoadingTables,
    showTableDropdown,
    setShowTableDropdown,
    
    // Regions
    regions,
    setRegions,
    selectedRegion,
    setSelectedRegion,
    regionDisplayMap,
    setRegionDisplayMap,
    loadingRegions,
    setLoadingRegions,
    showRegionDropdown,
    setShowRegionDropdown,
    regionsData,
    setRegionsData,
    
    // DataSource
    dataSourceId,
    setDataSourceId,
    
    // Methods
    resetSelections,
  };
};
